import type { ChatMessage } from './messages';

export interface MessageActions {
  onReply?: (m: ChatMessage) => void;
  onCopyToSend?: (m: ChatMessage) => void;
  onUnsend?: (messageId: string) => Promise<void>;
  onLike?: (messageId: string, liked: boolean) => Promise<void>;
  onTranslate?: (m: ChatMessage) => void;
}

/** What may be done to a message: unsend only our own sent ones, like only the fan's (OnlyFans' rules). */
export function messageRights(m: ChatMessage, a: MessageActions) {
  const sent = /^\d+$/.test(m.id);
  const mine = m.side === 'creator';
  return {
    unsend: mine && !!a.onUnsend && sent,
    like: !mine && !m.liked && !!a.onLike && sent,
    unlike: !mine && !!m.liked && !!a.onLike && sent,
  };
}
